import { IHistoryFilter } from '../interfaces/history-filter.interface';
import { IHistoryItem } from '../interfaces/history-item.interface';

export const historySorter = (
  chatA: IHistoryItem,
  chatB: IHistoryItem,
  filter: IHistoryFilter,
) => {
  const orderBy = filter?.orderBy;

  if (!orderBy) {
    return 0;
  }

  const a = chatA[orderBy.field] as Date;
  const b = chatB[orderBy.field] as Date;

  switch (orderBy.direction) {
    case 'desc':
      return a.getTime() - b.getTime();
    case 'asc':
    default:
      return b.getTime() - a.getTime();
  }
};
